import ReadAloud from "@/views/ReadAloud";
import CreateReadAloud from "@/components/read-aloud/CreateReadAloud";
import EditReadAloud from "@/components/read-aloud/EditReadAloud";
import ReadAloudDetails from "@/views/ReadAloudDetails";

const readaloudRoutes = [
  {
    path: "/organization/:organizationId/read-aloud",
    name: "read-aloud",
    component: ReadAloud,
    props: true,
    meta: {
      menuItemIndex: "13",
      title: "Read Aloud",
    },
  },
  {
    path: "/organization/:organizationId/curriculum/read-aloud/new",
    name: "read-aloud-new",
    component: CreateReadAloud,
    props: true,
    meta: {
      menuItemIndex: "12",
      title: "Create Study Set",
    },
  },
  {
    path: "/organization/:organizationId/curriculum/read-aloud/:readAloudId",
    name: "read-aloud-details",
    component: ReadAloudDetails,
    props: true,
    meta: {
      menuItemIndex: "12",
      title: "Read Aloud Details",
    },
  },
  {
    path: "/organization/:organizationId/curriculum/read-aloud/:readAloudId/edit",
    name: "read-aloud-edit",
    component: EditReadAloud,
    props: true,
    meta: {
      menuItemIndex: "12",
      title: "Edit Study Set",
    },
  }
];

export default readaloudRoutes;
